import Swiper from "swiper";
import {MD_WIDTH} from "@main/helpers/const";

class ProgramDocumentsSlider {
    constructor(el) {
        this.el = el;
        this.resizeObserver = new ResizeObserver(this.onResizeWindow.bind(this), 200);
        this.resizeObserver.observe(document.body);
    }

    onResizeWindow([entry]) {
        if (entry.contentRect.width >= MD_WIDTH && this.swiper) {
            this.swiper.destroy(true, false);
            delete this.swiper;
        } else if (entry.contentRect.width < MD_WIDTH && !this.swiper) {
            this.createSlider();
        }
    }

    createSlider() {
        this.swiper = new Swiper(this.el, {
            slidesPerView: "auto",
            clickable: true,
            slideToClickedSlide: true,
            spaceBetween: 8,
        });
    }
}

document.querySelectorAll(".js-program-documents").forEach((el) => new ProgramDocumentsSlider(el));
